import { j as i } from "./jsx-runtime.DGlMoOmv.js";
import * as t from "react";
import { c as m } from "./index.CxSWpsOB.js";
const C = "tw-flex tw-flex-col tw-overflow-hidden tw-rounded-8", j = {
  outline: "tw-border tw-border-solid tw-border-gray-400 tw-bg-base-white",
  // Brand-gradient-1 border via layered backgrounds; mirrors the trick used
  // in `ItemV2.const.ts` highlight variant. The inner fill (`purple-100`)
  // shows through the ghost child rows so the card reads as one purple
  // surface. Ghost children's default `tw-bg-gray-200` hover is overridden
  // to `purple-200` via a descendant selector so hover stays on-palette.
  highlight: ["tw-border-2 tw-border-transparent", "[background-image:linear-gradient(var(--gradient-inner-bg,#ffffff),var(--gradient-inner-bg,#ffffff)),linear-gradient(135deg,#6C30D1,#A930D1)]", "[background-origin:border-box]", "[background-clip:padding-box,border-box]", "[--gradient-inner-bg:#F9F7FD]", "[&_[data-slot=item-v2]:hover]:tw-bg-purple-200"].join(" ")
}, D = {
  outline: "tw-border-t tw-border-solid tw-border-gray-400",
  highlight: "tw-border-t tw-border-solid tw-border-purple-300"
}, r = 8, L = (n) => {
  switch (n) {
    case "solo":
    case "head-collapsed":
      return {
        borderRadius: r
      };
    case "head-expanded":
      return {
        borderTopLeftRadius: r,
        borderTopRightRadius: r,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
      };
    case "last":
      return {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: r,
        borderBottomRightRadius: r
      };
    case "middle":
    default:
      return {
        borderRadius: 0
      };
  }
}, S = t.forwardRef(({
  children: n,
  className: f,
  contentSize: u,
  defaultExpanded: w = !1,
  size: R = "md",
  variant: o = "outline"
}, b) => {
  const [s, x] = t.useState(w), d = t.Children.toArray(n).filter(t.isValidElement);
  if (d.length === 0)
    return null;
  const l = (e, a) => t.cloneElement(e, {
    ...u !== void 0 ? {
      contentSize: e.props.contentSize ?? u
    } : {},
    size: e.props.size ?? R,
    variant: "ghost",
    style: {
      ...L(a),
      ...e.props.style
    }
  }), p = m(C, j[o], f);
  if (d.length === 1)
    return /* @__PURE__ */ i.jsx("div", { ref: b, "data-slot": "item-group", "data-variant": o, className: p, children: l(d[0], "solo") });
  const [c, ...g] = d, v = c.props.onClick, k = c.props.buttonOnClick, h = () => x((e) => !e), y = t.cloneElement(l(c, s ? "head-expanded" : "head-collapsed"), {
    onClick: () => {
      v?.(), h();
    },
    buttonOnClick: () => {
      k?.(), h();
    },
    // Force the default rotating chevron on the header regardless of
    // what a caller may have passed — the carrot is the group's expand
    // affordance and shouldn't be overridable per row.
    buttonIcon: void 0,
    buttonLabel: void 0,
    expanded: s
  });
  return /* @__PURE__ */ i.jsxs("div", { ref: b, "data-slot": "item-group", "data-variant": o, className: p, children: [
    y,
    s && /* @__PURE__ */ i.jsx("div", { role: "region", "aria-label": "Nested items", className: m("tw-flex tw-flex-col", D[o]), children: g.map((e, a) => {
      const B = a === g.length - 1;
      return /* @__PURE__ */ i.jsx(t.Fragment, { children: l(e, B ? "last" : "middle") }, e.key ?? a);
    }) })
  ] });
});
S.displayName = "ItemGroup";
export {
  S as I
};
//# sourceMappingURL=ItemGroup.BoGmhka9.js.map
